import { ProgressFlow } from '@approvalmax/ui';
import { memo } from 'react';

import { messages } from './StepsIndicator.messages';
import { Root } from './StepsIndicator.styles';
import { StepOneProps } from './StepsIndicator.types';

const StepsIndicator = memo<StepOneProps>((props) => {
    const { activeStep, hide } = props;

    return (
        <Root hide={hide}>
            <ProgressFlow
                steps={[
                    { text: messages.general },
                    { text: messages.paymentMethod },
                    { text: messages.additionalDetails },
                    { text: messages.preview },
                ]}
                activeStepIndex={activeStep}
            />
        </Root>
    );
});

export default StepsIndicator;
